<template>
    <div v-if="!error">
        <v-card
            :class="`mt-3 geral-docs-card ${!mobile ? 'mr-4' : ''}`"
            v-show="items.length > 0"
            v-for="(item, i) in items.filter(o => isFiltered(o))"
            :key="i"
        >
            <v-card-title
                :style="{ color: themeColor }"
                class="geral-docs-card__title"
                primary-title
            >
                {{ item.title }}
                <v-layout align-end justify-space-between column>
                <div class="geral-docs-card__date">
                    {{ formatDate(item.lastModified) }}
                </div>
                <div
                        class="geral-docs-card__status"
                        :class="{'geral-docs-card__status__visualized': visualized[item._id]}"
                    >
                    <i :class="`bexsicon-${geralDocumentIcons(visualized[item._id])}`" />  {{ visualized[item._id] ? $t('pages.documents.read') : $t('pages.documents.unRead') }}
                </div>
                </v-layout>
            </v-card-title>
            <v-card-text>
                {{ item.description }}
            </v-card-text>
            <v-card-actions>
                <v-btn
                    v-if="item.attachment"
                    :style="{ color: themeColor }"
                    @click="$emit('previewFile', item)"
                >
                    <i class="bexsicon-docs-sm" />
                    {{ $t('pages.documents.showDocumentBtn') }}
                </v-btn>
            </v-card-actions>
        </v-card>
        <div
            v-show="items.length === 0"
            class="empty-state"
        >
            {{ emptyState }}
        </div>
    </div>
</template>

<script>
import { NOTIFICATIONS } from '../../utils/constants';
export default {
  name: 'geral-doc-list',
  props: {
    items: {
      type: Array,
      required: true
    },
    emptyState: {
      type: String,
      required: true
    },
    themeColor: {
      type: String,
      required: true
    },
    visualizedFilter: {
      type: Boolean,
      default: null
    },
    error: {
      type: Boolean
    }
  },
  computed: {
    visualized() {
      return this.$store.getters[NOTIFICATIONS.GET_VISUALIZED];
    }
  },
  methods: {
    isFiltered(item) {
      if (this.visualizedFilter == null) {
        return true;
      } else {
        return !!this.visualized[item._id] === this.visualizedFilter;
      }
    },
    geralDocumentIcons(visualized) {
      return visualized ? 'msg-sent' : 'close';
    },
    geralDocumentStyle(visualized) {
      if (visualized) {
        return {
          backgroundColor: '#33cc1e',
          color: '#fff'
        };
      } else {
        return {};
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';
.geral-docs-card {
  margin-bottom: 1em;
  &__date {
    font-size: 0.7em;
    text-align: right;
    flex: 1;
    padding: 0 1em;
    color: var(--label-color);
  }

  &__title {
    font-size: 1.3em;
    padding-bottom: 0;
    @include breakpoint(mobile) {
      font-size: 1.05em;
    }
  }

  &:last-of-type {
    margin-bottom: 30px;
  }

  &__visualized {
    font-size: 0.5em;
    text-align: center;
    color: gray;
    background-color: lightgray;
    padding: 0.2em 1em;
    &_not {
      font-weight: bold;
      color: lightgray;
      background-color: gray;
    }
  }

  &__status {
    width: 90px;
    font-size: 0.7em;
    margin-left: auto;
    text-align: center;
    right: 1em;
    background-color: var(--not-visualized-color);
    color: #f5f5f5;
    padding: 0.15em 0.5em;
    border-radius: 25px;
    @include breakpoint(mobile) {
      padding: 0.15em 0.3em;
      width: 70px;
    }

    &__visualized {
      background-color: #33cc1e;
      color: #fff;
    }

    i {
      padding: 0 0.1em;
      font-size: 0.8em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/document/GeralDocList.vue